import { registerSymbol } from "../serializers/symbolSerializer";
import { getRenderedPolygonCoordinates } from "../utils/math";
import { FillStyle, PolyRender } from "../renders/Poly";
import { Symbol } from "./Symbol";
import { H3Feature } from "../features/H3Feature";
/**
 * Symbol of h3 drawn as hexagon with outline.
 * @alias sGis.hexagon.h3
 */
export class H3Symbol extends Symbol {
    /**
     * @param options - key-value list of the properties to be assigned to the instance.
     */
    constructor(options = {}) {
        super();
        /** Diameter of the cell. */
        this.cellSize = 10;
        /** Color of the inner part of the symbol. Can be any valid css color string. */
        this.fillColor = 'black';
        /** Color of the outline of the symbol. Can be any valid css color string. */
        this.strokeColor = 'transparent';
        /** Width of the outline. */
        this.strokeWidth = 1;
        Object.assign(this, options);
    }
    renderFunction(feature, resolution, crs) {
        if (!(feature instanceof H3Feature))
            return [];
        let coordinates = getRenderedPolygonCoordinates(feature, resolution, crs);
        return [new PolyRender(coordinates, {
                enclosed: true,
                fillStyle: FillStyle.Color,
                strokeColor: this.strokeColor,
                strokeWidth: this.strokeWidth,
                fillColor: this.fillColor,
            })];
    }
}
registerSymbol(H3Symbol, 'hexagon.h3', ['cellSize', 'fillColor', 'strokeColor', 'strokeWidth']);
